import { render, staticRenderFns } from "./style3.vue?vue&type=template&id=835e9adc&scoped=true&"
import script from "./style3.vue?vue&type=script&lang=js&"
export * from "./style3.vue?vue&type=script&lang=js&"
import style0 from "./style3.vue?vue&type=style&index=0&id=835e9adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835e9adc",
  null
  
)

export default component.exports